import React from "react";
import { useSelector } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Iframe from "./Iframe.js";
import { useHistory } from "react-router-dom";

export default props => {
    const history = useHistory();
    const therapist = useSelector(state => state.data.therapist);
    const protocol = `${window.location.protocol}//`;
    const host = window.location.host;
    const pathname = "/onlineBooking";
    const search = `?therapistId=${therapist.id}`;
    const src = `${protocol}${host}${pathname}${search}`;
    return (
        <div style={{ padding: "20px" }}>
            <Typography variant="body1">
                Der er to forskellige muligheder for at give dine klienter denne mulighed.
            </Typography>
            <ol>
                <li>
                    Ved at kopiere den følgende BLÅ linje til Facebook eller til din hjemmeside. Når din klient klikker
                    på linjen, vil der åbne sig et nyt vindue, hvori klienten kan booke en tid.
                    <br />
                    <br />
                    <Link
                        to={{
                            pathname: pathname,
                            search: search
                        }}
                        style={{ color: "blue" }}>
                        {src}
                    </Link>
                    <br />
                    <br />
                </li>
                <li>
                    Hvis du er mere teknisk, kan du til programmeringen af din hjemmeside føje det html-tag, som står i
                    vinduet lidt længere nede:
                    <div style={{ height: "20px" }} />
                    <Typography variant="body1">{`<iframe title="Online Booking"style="width:100%;height:1000px;"src="${src}"></iframe>`}</Typography>
                    <div style={{ height: "20px" }} />
                    <Typography variant="body1">
                        Ovenstående link vil resultere i at følgende boks kommer på din hjemmeside:
                    </Typography>
                    <div style={{ height: "20px" }} />
                    <Iframe title="Online Booking" src={src} />
                    <Button variant="contained" color="primary" onClick={() => history.push("/Kalender")}>
                        Gå til kalenderen
                    </Button>
                </li>
            </ol>
        </div>
    );
};
